/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/factory5.glb");
	materials["Material.002"].color.set(0x000000);

	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder001.geometry}
				material={materials["Material.002"]}
				position={[1.444, 0.143, -0.226]}
				rotation={[-0.109, 0, -Math.PI / 2]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder003.geometry}
				material={materials["Material.002"]}
				position={[1.775, 0.143, -0.226]}
				rotation={[-0.109, 0, -Math.PI / 2]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube005.geometry}
				material={materials["Material.002"]}
				position={[1.939, 0.476, -1.118]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane.geometry}
				material={materials["Material.002"]}
				position={[1.229, 0.199, -0.764]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.225}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder004.geometry}
				material={materials["Material.002"]}
				position={[1.54, 1.116, -1.324]}
				scale={[0.899, 0.909, 0.899]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder005.geometry}
				material={materials["Material.002"]}
				position={[1.806, 1.116, -1.324]}
				scale={[0.899, 0.909, 0.899]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube035.geometry}
				material={materials["Material.002"]}
				position={[1.668, 0.379, -2.591]}
				rotation={[0, -1.571, 0]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube021.geometry}
				material={materials["Material.002"]}
				position={[1.605, 0.952, -0.76]}
				scale={0.045}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube007.geometry}
				material={materials["Material.002"]}
				position={[1.89, 0.476, -1.118]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube009.geometry}
				material={materials["Material.002"]}
				position={[1.401, 0.828, -1.675]}
				scale={0.841}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube010.geometry}
				material={materials["Material.002"]}
				position={[2.018, 0.828, -1.644]}
				rotation={[0, -1.571, 0]}
				scale={0.841}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube011.geometry}
				material={materials["Material.002"]}
				position={[1.371, 0.828, -1.335]}
				rotation={[0, 1.571, 0]}
				scale={0.841}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube012.geometry}
				material={materials["Material.002"]}
				position={[1.351, 0.405, -1.723]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube013.geometry}
				material={materials["Material.002"]}
				position={[2.121, 0.405, -1.687]}
				rotation={[0, -1.571, 0]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube015.geometry}
				material={materials["Material.002"]}
				position={[1.315, 0.405, -1.32]}
				rotation={[0, 1.571, 0]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube016.geometry}
				material={materials["Material.002"]}
				position={[1.624, 1.294, -1.073]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath.geometry}
				material={materials["Material.002"]}
				position={[1.905, 1.367, -0.896]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.063}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath001.geometry}
				material={materials["Material.002"]}
				position={[1.905, 1.367, -0.83]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.063}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath002.geometry}
				material={materials["Material.002"]}
				position={[1.905, 1.367, -0.706]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.063}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath003.geometry}
				material={materials["Material.002"]}
				position={[1.905, 1.367, -0.64]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.063}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube017.geometry}
				material={materials["Material.002"]}
				position={[1.904, 1.268, -0.766]}
				scale={[0.045, 0.045, 0.18]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube006.geometry}
				material={materials["Material.002"]}
				position={[1.513, 0.122, -2.098]}
				scale={[1, 0.696, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube018.geometry}
				material={materials["Material.002"]}
				position={[1.727, 0.122, -2.098]}
				scale={[1, 0.696, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube019.geometry}
				material={materials["Material.002"]}
				position={[1.942, 0.122, -2.098]}
				scale={[1, 0.696, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube020.geometry}
				material={materials["Material.002"]}
				position={[1.536, 0.092, 1.643]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder006.geometry}
				material={materials["Material.002"]}
				position={[1.547, 0.424, 1.129]}
				rotation={[0, 0, -Math.PI / 2]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube022.geometry}
				material={materials["Material.002"]}
				position={[1.128, 0.372, 1.481]}
				scale={[0.395, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube023.geometry}
				material={materials["Material.002"]}
				position={[1.947, 0.372, 1.481]}
				scale={[0.511, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube024.geometry}
				material={materials["Material.002"]}
				position={[1.378, 0.659, -1.717]}
				scale={0.968}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube025.geometry}
				material={materials["Material.002"]}
				position={[2.118, 0.659, -1.682]}
				rotation={[0, -Math.PI / 2, 0]}
				scale={0.968}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube026.geometry}
				material={materials["Material.002"]}
				position={[1.344, 0.659, -1.327]}
				rotation={[0, Math.PI / 2, 0]}
				scale={0.968}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube027.geometry}
				material={materials["Material.002"]}
				position={[2.296, 0.065, 0.296]}
				scale={[1, 0.738, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder007.geometry}
				material={materials["Material.002"]}
				position={[2.296, 0.915, 0.296]}
				scale={[0.079, 0.455, 0.079]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube028.geometry}
				material={materials["Material.002"]}
				position={[2.296, 0.065, 0.688]}
				scale={[1, 0.738, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder008.geometry}
				material={materials["Material.002"]}
				position={[2.296, 0.915, 0.688]}
				scale={[0.079, 0.455, 0.079]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath004.geometry}
				material={materials["Material.002"]}
				position={[2.101, 0.316, 1.826]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.058}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath005.geometry}
				material={materials["Material.002"]}
				position={[2.101, 0.316, 1.481]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.058}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath006.geometry}
				material={materials["Material.002"]}
				position={[2.101, 0.316, 1.127]}
				rotation={[0, 0, -Math.PI / 2]}
				scale={0.058}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube029.geometry}
				material={materials["Material.002"]}
				position={[1.218, 0.122, -2.843]}
				rotation={[0, -1.571, 0]}
				scale={[1, 0.696, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube030.geometry}
				material={materials["Material.002"]}
				position={[1.218, 0.122, -2.628]}
				rotation={[0, -1.571, 0]}
				scale={[1, 0.696, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube031.geometry}
				material={materials["Material.002"]}
				position={[1.218, 0.122, -2.413]}
				rotation={[0, -1.571, 0]}
				scale={[1, 0.696, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube032.geometry}
				material={materials["Material.002"]}
				position={[1.664, 0.301, -2.586]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube033.geometry}
				material={materials["Material.002"]}
				position={[1.72, 0.22, -2.608]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder009.geometry}
				material={materials["Material.002"]}
				position={[2.023, 1.14, -2.94]}
				scale={[0.426, 0.676, 0.426]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder010.geometry}
				material={materials["Material.002"]}
				position={[-0.584, 1.345, -2.76]}
				scale={[0.051, 0.332, 0.051]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder011.geometry}
				material={materials["Material.002"]}
				position={[-0.159, 1.345, -2.76]}
				scale={[0.051, 0.332, 0.051]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder012.geometry}
				material={materials["Material.002"]}
				position={[0.262, 1.345, -2.76]}
				scale={[0.051, 0.332, 0.051]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube.geometry}
				material={materials["Material.002"]}
				position={[-0.061, 0, -0.363]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube001.geometry}
				material={materials["Material.002"]}
				position={[1.604, 0.629, -0.774]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder.geometry}
				material={materials["Material.002"]}
				position={[1.444, 0.025, -0.344]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={[0.877, 0.066, 0.877]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder002.geometry}
				material={materials["Material.002"]}
				position={[1.775, 0.025, -0.344]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={[0.877, 0.066, 0.877]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube034.geometry}
				material={materials["Material.002"]}
				position={[-0.161, 0.374, -2.637]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube036.geometry}
				material={materials["Material.002"]}
				position={[-0.632, 0.627, -2.926]}
				scale={[0.777, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube037.geometry}
				material={materials["Material.002"]}
				position={[-0.535, 0.627, -2.926]}
				scale={[0.777, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube038.geometry}
				material={materials["Material.002"]}
				position={[-0.206, 0.627, -2.926]}
				scale={[0.777, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube039.geometry}
				material={materials["Material.002"]}
				position={[-0.109, 0.627, -2.926]}
				scale={[0.777, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube040.geometry}
				material={materials["Material.002"]}
				position={[0.212, 0.627, -2.926]}
				scale={[0.777, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube041.geometry}
				material={materials["Material.002"]}
				position={[0.309, 0.627, -2.926]}
				scale={[0.777, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane001.geometry}
				material={materials["Material.002"]}
				position={[-2.676, 0.522, -2.155]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[1, 1, 0.72]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane002.geometry}
				material={materials["Material.002"]}
				position={[-2.448, 0.467, -2.055]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.823, 0.823, 0.593]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane003.geometry}
				material={materials["Material.002"]}
				position={[-2.24, 0.419, -1.946]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.651, 0.651, 0.469]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube042.geometry}
				material={materials["Material.002"]}
				position={[-2.068, 0.1, -2.176]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube043.geometry}
				material={materials["Material.002"]}
				position={[-0.402, 0.251, 1.281]}
				scale={0.858}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube044.geometry}
				material={materials["Material.002"]}
				position={[-2.351, 0.2, -0.144]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder013.geometry}
				material={materials["Material.002"]}
				position={[-2.334, 0.869, 1.283]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube045.geometry}
				material={materials["Material.002"]}
				position={[-2.353, 0.319, 1.281]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane004.geometry}
				material={materials["Material.002"]}
				position={[-2.336, 0.15, 1.016]}
				scale={[0.379, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder014.geometry}
				material={materials["Material.002"]}
				position={[1.446, 0.802, 0.051]}
				rotation={[1.774, 0.025, 0.122]}
				scale={[0.004, 0.616, 0.004]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder015.geometry}
				material={materials["Material.002"]}
				position={[1.446, 0.802, 0.051]}
				rotation={[1.776, 0.007, 0.032]}
				scale={[0.004, 0.616, 0.004]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder016.geometry}
				material={materials["Material.002"]}
				position={[1.446, 0.802, 0.051]}
				rotation={[1.776, -0.012, -0.056]}
				scale={[0.004, 0.616, 0.004]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder017.geometry}
				material={materials["Material.002"]}
				position={[1.771, 0.802, 0.051]}
				rotation={[-1.366, 0.004, 0.018]}
				scale={[-0.004, -0.616, -0.004]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder018.geometry}
				material={materials["Material.002"]}
				position={[1.771, 0.802, 0.051]}
				rotation={[-1.366, -0.005, -0.024]}
				scale={[-0.004, -0.616, -0.004]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder019.geometry}
				material={materials["Material.002"]}
				position={[1.771, 0.802, 0.051]}
				rotation={[-1.367, -0.021, -0.1]}
				scale={[-0.004, -0.616, -0.004]}
			/>
			<group position={[-0.624, 0.027, -0.699]} scale={0.719}>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane005_1.geometry}
					material={materials["Material.003"]}
				/>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane005_2.geometry}
					material={materials["Material.004"]}
				/>
			</group>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube049.geometry}
				material={materials["Material.002"]}
				position={[1.491, 1.329, -0.595]}
			/>
		</group>
	);
}

useGLTF.preload("models/factory5.glb");
